<template>
	<div class="add_group_wrap">
     <el-button type="primary" size="small" @click="pop_show = true" class="pull-right">增加用户组</el-button>
     <el-dialog title="增加用户组" :visible.sync="pop_show" append-to-body width="54%">
        <el-form :model="groupForm" status-icon :rules="rulesGroupForm" ref="groupForm" label-width="100px">
          <el-form-item label="角色：" prop="name">
            <el-input type="text" v-model="groupForm.name" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>
          <el-form-item label="页面权限点：" prop="permission_ids">
            <!-- <template>
              <el-collapse accordion v-for='i in arr1' @change='fn1(i.permission_id)' style="border:0">
                <el-collapse-item>
                  <template slot="title">
                    <input type="checkbox" @click.stop :value='i.permission_id' v-model="checkedArr1"/>
                    &emsp;一级菜单: {{i.name}}
                  </template>

                  <el-collapse class='aaa' accordion v-for='j in arr2' @change='fn2(j.permission_id)' style="border:0">
                    <el-collapse-item>
                      <template slot="title">
                        <input @click.stop type="checkbox" :value='j.permission_id' v-model="checkedArr2"/>
                        &emsp;二级菜单: {{j.name}}
                      </template>

                      <div v-for='k in arr3' class="bbb">
                        <input type="checkbox" :value='k.permission_id' v-model="checkedArr3"/>
                        &emsp;权限点: {{k.name}}
                      </div>
                    </el-collapse-item>
                  </el-collapse>

                </el-collapse-item>
              </el-collapse>
            </template> -->

            <!-- 一级菜单 -->
            <div v-for='i in arr1' style="cursor: pointer;">
              <div @click='fn1(i.permission_id)'>
                <img v-if='i.permission_id==flag1' src="static/images/xia.png" style="height: 5px">
                <img v-else src="static/images/you.png" style="height: 10px">

                <input @click.stop type="checkbox" :value='i.permission_id' v-model='checkedArr1'>
                <span>&emsp;{{i.name}}</span>
              </div>
              <div v-if='i.permission_id==flag1'>
                <!-- 二级菜单 -->
                <div v-for='j in arr2' style="padding-left: 60px">
                  <div @click='fn2(j.permission_id)'>
                    <img v-if='j.permission_id==flag2' src="static/images/xia.png" style="height: 5px">
                    <img v-else src="static/images/you.png" style="height: 10px">

                    <input @click.stop type="checkbox" :value='j.permission_id' v-model='checkedArr2'>
                    <span>&emsp;{{j.name}}</span>
                  </div>
                  <div v-if='j.permission_id==flag2'>
                    <!-- 权限点 -->
                    <div v-for='k in arr3' style="padding-left: 60px">
                      <div>
                        <input @click.stop type="checkbox" :value='i.permission_id' v-model='checkedArr3'>
                        <span>&emsp;{{k.name}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>



          </el-form-item>
          <el-form-item label="是否启用：" prop="status">
            <template>
              <el-radio-group v-model="groupForm.status">
                <el-radio :label="0">禁用</el-radio>
                <el-radio :label="1">启用</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input type="text" v-model="groupForm.remark" autocomplete="off" size="small" class="input_width"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="resetForm('groupForm')">重置</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
	</div>
</template>

<script>
import cons from '@/components/constant';

export default {
  name: 'AddGroup',
  data () {
    var validateName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('角色不能为空'));
        } else {
          callback()
        }
    };
    return {
      pop_show:false,
      checkedArr1: [],
      checkedArr2: [],
      checkedArr3: [],
      arr1: [],
      arr2: [],
      arr3: [],
      flag1: '',
      flag2: '',
      checkedCities: [],
      isIndeterminate: true,
      groupForm:{
        name:'',
        status:'',
        remark:'',
      },
      rulesGroupForm:{
        name: [
            { validator:validateName, trigger: 'blur'}
        ]
      }
    }
  },
  methods:{
    submitForm(){
        if(this.groupForm.name == '' || this.checkedArr1.concat(this.checkedArr2).concat(this.checkedArr3).length===0){
          this.$message({
              type:'error',
              message:'请输入用户名并选择权限！'
          });
          return
        }
        if(this.groupForm.status == ''){
          this.$message({
              type:'error',
              message:'请选择状态！'
          });
          return
        }
        let token = localStorage.token;
        this.axios.post(cons.apis + '/v1_0/groups', {
              "name":this.groupForm.name,
              "remark":this.groupForm.remark,
              "status":this.groupForm.status,
              "permission_ids":this.checkedArr1.concat(this.checkedArr2).concat(this.checkedArr3)
            },{
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json'
        })
        .then(dat=>{
            if(dat.status==200){
              this.$message({
                type: 'success',
                message: '添加组成功!'
              });
              this.pop_show = false;

              this.checkedArr1 = []
              this.checkedArr2 = []
              this.checkedArr3 = []

              this.flag1 = ''
              this.flag2 = ''

              this.resetForm('groupForm')
              this.$emit('fnResetTable');
            }
        }).catch(err=>{
           if(err.response.status==400){
               this.$message({
                  type:'error',
                  message:'状态不能为空'
              });
           }
           if(err.response.status==403){
               this.$message({
                  type:'error',
                  message:'用户名已存在'
              });
           }
        });
    },
    fnGetPowerList(){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/permissions', {
        headers: {
          'Authorization': 'Bearer ' + token
        },
       responseType: 'json',
       params:{
          parent_id: 0,
          type: 0
        }
      })
      .then(dat=>{
          this.arr1 = dat.data.data.permissions

      }).catch(err=>{
         console.log(err.response);
      });
    },
    resetForm(formName){
      this.$refs[formName].resetFields();
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.arr.length;
    },
    fn1(pid){
      this.flag1 = this.flag1===pid?'':pid
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/permissions', {
        headers: {
          'Authorization': 'Bearer ' + token
        },
       responseType: 'json',
       params:{
          parent_id: pid,
          type: 0
        }
      })
      .then(dat=>{
          this.arr2 = dat.data.data.permissions

      }).catch(err=>{
         console.log(err.response);
      });
    },
    fn2(pid){
      this.flag2 = this.flag2===pid?'':pid
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/permissions', {
        headers: {
          'Authorization': 'Bearer ' + token
        },
       responseType: 'json',
       params:{
          parent_id: pid,
          type: 1
        }
      })
      .then(dat=>{
          this.arr3 = dat.data.data.permissions

      }).catch(err=>{
         console.log(err.response);
      });
    }
  },
  mounted(){
    this.fnGetPowerList();
  }
}
</script>
<style>
  .el-collapse-item__header {
    border: 0;
  }
  .aaa .el-collapse-item__header {
    height: 34px;
  }
.bbb .el-collapse-item__header {
    height: 30px;
  }



  .el-collapse-item__content {
    padding-bottom: 0
  }

  .aaa {
    padding-left: 60px;
  }
.bbb {
    padding-left: 60px;
  }

</style>



// WEBPACK FOOTER //
// src/components/widget/AddGroup.vue